<template>
  <div>
    <div class="sign-logo w1200">
      <h1 class="sh_logo">
        <a href="#" title="山河医学网"
          ><img src="../../public/imgs/3h-白底.png"
        /></a>
      </h1>
    </div>

    <div class="sign-con w1200">
      <img src="../../public/imgs/5轮播图-750x400.jpg" class="sign-contu f-l" />
      <div class="sign-ipt f-l">
        <el-form label-position="right" @submit.native.prevent="login"
          >         
          <el-form-item label="账号">
                             
            <el-input type="text" v-model="model.username"></el-input>           </el-form-item
          >           
          <el-form-item label="密码">
                             
            <el-input type="password" v-model="model.password"></el-input>    
                      
          </el-form-item>
                         
          <el-form-item>
                               
            <el-button style="float: right" type="primary" native-type="submit"
              >登录</el-button
            > </el-form-item
          >       
        </el-form>
      </div>
      <div style="clear: both"></div>
    </div>

    <!--底部 版权-->
    <div class="footer w1200">
      <p>
        <a href="#">关于我们</a><span>|</span> <a href="#">友情链接</a
        ><span>|</span> <a href="#">官方网站</a><span>|</span>
        <a href="#">诚征英才</a>
      </p>
      <p>
        皖ICP备17028855号<span>|</span> <a href=""> www.3hvip.com</a
        ><span>|</span><a href="">营业执照</a><span>|</span>power by
        山河医学网<span>|</span>Copyright © 2016 - 2046 All Rights Reserved.
      </p>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      model: {},
    };
  },
  methods: {
    async login() {
      const res = await this.$http.post("/login", this.model);
      //this.username = await res.data.username;
      //设置token

      //console.log(res.data.token);
      localStorage.token = await res.data.token;
      this.$router.push("/");
      this.$message({
        type: "success",
        message: "登录成功，欢迎" + `${res.data.username}`,
      });
    },
  },
};
</script>

<style>
.w1200 {
  width: 1200px;
  margin: 0 auto;
}
.mt20 {
  margin-top: 20px;
}
.f-l {
  float: left;
}
.f-r {
  float: right;
}
.none {
  display: none;
}
.el-form-item {
  margin-right: 55px;
}
.sign-logo {
  width: 1172px;
  padding: 32px 0 38px 28px;
}
.sh_logo a img {
  width: 15%;
}

.sign-con {
  height: 500px;
}
.sign-con .sign-contu {
  margin: 5px 45px 48px 20px;
}
.sign-con .sign-ipt {
  width: 325px;
  height: 300px;
  border: 1px solid #cbcbcb;
  margin-top: 30px;
  padding: 40px 0 0 45px;
}
.sign-con .sign-ipt p {
  width: 280px;
  font-size: 15px;
  color: #272727;
  margin: 8px 0px 5px;
}

.sign-con .sign-ipt p .wj {
  float: right;
}
.sign-con .sign-ipt input {
  width: 270px;
  height: 36px;
  border: 1px solid #ccc;
  padding: 0 5px;
  color: #a1a0a0;
  font-size: 13px;
}
.sign-con img {
  filter: opacity(35%);
}
.sign-con .sign-ipt .sign-qx {
  width: 280px;
  margin-top: 15px;
}
.sign-con .sign-ipt .sign-qx .qq {
  margin-right: 10px;
}

/*底部 版权*/
.footer {
  margin-top: 150px;
  text-align: center;
}
.footer p {
  height: 30px;
  font-size: 14px;
  color: #000;
}
.footer p a {
  display: inline-block;
  font-size: 14px;
  color: #000;
  text-decoration: none;
}
.footer p a:hover {
  color: #190aeb;
}
.footer p span {
  margin: 0 8px 0 10px;
}
</style>
